<template>
  <div>
    <div @mousemove="move" class="w3l-banner">
      <div :style="
        'transform: translate(' +
        (position == 'left' ? '20' : '-20') +
        'px,' +
        (position2 == 'top' ? '10' : '-10') +
        'px) scale(1.1)'
      " class="banner-image"></div>
      <div class="titleBox" :class="contType == 'e' ? 'titleBoxe' : ''">
        <div class="wow flipInX titleT1" :class="contType == 'e' ? 'titleT1e' : ''">{{ contList.title1[contType] }}</div>
        <div class="wow flipInX titleT2">{{ contList.title2[contType] }}</div>
        <div class="wow flipInX titleT22">{{ contType == 'e' ? contList.title22[contType][0] + contList.title22[contType][1] : contList.title22[contType][0] + '\n' + contList.title22[contType][1] }}</div>
        <div class="wow flipInX experience">{{ contList.titleBtn[contType] }}</div>
        <img class="wow bounceInRight titlebgIcon1" src="../assets/img/ContactUs/icon.svg" alt="" />
        <img class="wow bounceInUp titlebg" src="../assets/img/ContactUs/person.svg" alt="" />
      </div>
    </div>

    <div class="bgBox">
      <div class="contBox">
        <div class="contTitle">{{ contList.title3[contType] }}</div>
        <div class="contSubtitle">{{ contList.title4[contType] }}</div>
        <div class="formBox">
          <el-form label-position="top" label-width="136px" :model="formData" ref="formData" :rules="rules">
            <div class="formColumn" style="display: flex;">
              <el-form-item :label="contList.formTitles[contType][0]" class="formItemL" prop="name">
                <el-input v-model="formData.name" :placeholder="contList.formTitles[contType][10]"></el-input>
              </el-form-item>
              <el-form-item :label="contList.formTitles[contType][1]" class="formItemR" prop="email">
                <el-input v-model="formData.email" :placeholder="contList.formTitles[contType][11]"></el-input>
              </el-form-item>
            </div>
            <div class="formColumn" style="display: flex">
              <el-form-item :label="contList.formTitles[contType][2]" class="formItemL" prop="mobile">
                <el-input v-model="formData.mobile" :placeholder="contList.formTitles[contType][12]"></el-input>
              </el-form-item>
              <el-form-item :label="contList.formTitles[contType][3]" class="formItemR" prop="company">
                <el-input v-model="formData.company" :placeholder="contList.formTitles[contType][13]"></el-input>
              </el-form-item>
            </div>
            <el-form-item :label="contList.formTitles[contType][4]" prop="url">
              <el-input v-model="formData.url" :placeholder="contList.formTitles[contType][14]"></el-input>
            </el-form-item>
            <el-form-item :label="contList.formTitles[contType][5]" prop="remark">
              <el-input v-model="formData.remark" type="textarea" resize="none" :rows="5"
                :placeholder="contList.formTitles[contType][15]"></el-input>
            </el-form-item>
            <!-- <el-form-item prop="checkbox">
              <el-checkbox class="checkboxText" v-model="formData.checkbox">
                <div style="font-size: 14px; width: calc(100% - 16px);">
                  <span>{{ contList.formTitles[contType][6] }}</span>
                  <span class="spUn" style="color: #2b82e9;margin: 0px;"> {{ contList.formTitles[contType][7] }} </span>
                  <span>{{ contList.formTitles[contType][8] }}</span>
                </div>
              </el-checkbox>
            </el-form-item> -->

            <el-form-item>
              <div class="botBox">
                <el-button type="primary" round class="submitBtn" @click="submitForm('formData')" :loading="isSend">{{
                  contList.formTitles[contType][9]
                }}</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- <script src="https://smtpjs.com/v3/smtp.js"></script> -->
<script>


import { Email } from "../utils/smtp.js";
import { WOW } from "wowjs";

export default {
  name: "index",
  data: (vm) => {
    var validateName = (rule, value, callback) => {
      let contType = window.localStorage.getItem("language");
      let errorStr = {
        z: "请输入姓名",
        f: "請輸入姓名",
        e: "Please enter a name",
      };
      if (value === "") {
        callback(new Error(errorStr[contType]));
      } else {
        callback();
      }
    };
    var validateEmail = (rule, value, callback) => {
      let contType = window.localStorage.getItem("language");
      let errorStr = {
        z: "请输入电子邮箱",
        f: "請輸入電子郵箱",
        e:'Please enter your email address'
      };
      if (value === "") {
        callback(new Error(errorStr[contType]));
      } else {
        callback();
      }
    };
    var validateMobile = (rule, value, callback) => {
      let contType = window.localStorage.getItem("language");
      let errorStr = {
        z: "请输入联系电话",
        f: "請輸入聯繫電話",
        e:'Please enter the contact number'
      };
      if (value === "") {
        callback(new Error(errorStr[contType]));
      } else {
        callback();
      }
    };
    var validateCompany = (rule, value, callback) => {
      let contType = window.localStorage.getItem("language");
      let errorStr = {
        z: "请输入公司名称",
        f: "請輸入公司名稱",
        e: 'Please enter a company name'
      };
      if (value === "") {
        callback(new Error(errorStr[contType]));
      } else {
        callback();
      }
    };
    var validateRemark = (rule, value, callback) => {
      let contType = window.localStorage.getItem("language");
      let errorStr = {
        z: "请输入留言内容",
        f: "請輸入留言內容",
        e:'Please enter the message'
      };
      if (value === "") {
        callback(new Error(errorStr[contType]));
      } else {
        callback();
      }
    };
    // var validateCheckbox = (rule, value, callback) => {
    //   let contType = window.localStorage.getItem("language");
    //   let errorStr = {
    //     z: "请阅读Suntone隐私协议，并同意后再次发送信息",
    //     f: "請閱讀Suntone隱私協議，並同意後再次髮送信息",
    //   };
    //   if (!value) {
    //     callback(new Error(errorStr[contType]));
    //   } else {
    //     callback();
    //   }
    // };
    return {
      bodyW: 0,
      bodyY: 0,
      position: "",
      position2: "",
      formData: {
        name: "",
        email: "",
        mobile: "",
        company: "",
        url: "",
        remark: "",
        // checkbox: false,
      },
      rules: {
        name: [{ validator: validateName, trigger: "blur" }],
        email: [{ validator: validateEmail, trigger: "blur" }],
        mobile: [{ validator: validateMobile, trigger: "blur" }],
        company: [{ validator: validateCompany, trigger: "blur" }],
        url: [{ required: false, message: "", trigger: "blur" }],
        remark: [{ validator: validateRemark, trigger: "blur" }],
        // checkbox: [{ validator: validateCheckbox, trigger: "change" }],
      },
      contList: {
        title1: {
          z: "联系我们",
          f: "聯繫我們",
          e: 'Contact Us'
        },
        title2: {
          z: "联系我们获取最新的跨境收付解决方案及行业资讯",
          f: "聯繫我們獲取最新的跨境收付解決方案及行業資訊",
          e:'Contact us for the latest cross-border payment solutions and industry news.'
        },
        title22: {
          z: [
            "联系我们获取最新的",
            "跨境收付解决方案及行业资讯",
          ],
          f: [
            "聯繫我們獲取最新的",
            "跨境收付解決方案及行業資訊",
          ],
          e: [
            "Contact us for the latest",
            "cross-border payment solutions and industry news",
          ],
        },
        titleBtn: {
          z: "cs@suntone.com",
          f: "cs@suntone.com",
          e: "cs@suntone.com",
        },
        title3: {
          z: "欢迎留言",
          f: "歡迎留言",
          e:'Welcome Your Message'
        },
        title4: {
          z: "我们会尽快联系您",
          f: "我們會儘快聯繫您",
          e:'We will contact you as soon as possible.'
        },
        formTitles: {
          z: [
            "姓名 *",
            "邮箱 *",
            "电话 *",
            "公司名称 *",
            "公司官网/产品链接",
            "留言 *",
            "您同意我们按照",
            "Suntone隐私政策",
            "来处理个人信息",
            "发送信息",
            "请输入姓名",
            "请输入电子邮箱",
            "请输入联系电话",
            "请输入公司名称",
            "请输入公司官网/产品链接",
            "请输入留言内容",
          ],
          f: [
            "姓名 *",
            "郵箱 *",
            "電話 *",
            "公司名稱 *",
            "公司官網/産品鏈接",
            "留言 *",
            "您同意我們按照",
            "Suntone隱私政策",
            "來處理個人信息",
            "髮送信息",
            "請輸入姓名",
            "請輸入電子郵箱",
            "請輸入聯繫電話",
            "請輸入公司名稱",
            "請輸入公司官網/産品鏈接",
            "請輸入留言內容",
          ],
          e: [
            "Name *",
            "E-mail *",
            "Contact number *",
            "Company name *",
            "Suntone's Official Website/Links of Products",
            "Message *",
            "You agree to process your information in accordance with",
            "Suntone's Privacy Policy",
            "",
            "Send",
            "Please enter a name",
            "Please enter your email address",
            "Please enter the contact number",
            "Please enter a company name",
            "Please enter the company's official website / product link",
            "Please enter the message",
          ],
        },
        email: {
          z: "信息已发送",
          f: "信息已髮送",
          e: "The information has been sent.",
        }
      },
      contType: "z",
      isSend: false
    };
  },
  methods: {
    move(e) {
      if (e.pageX > this.bodyW / 2) {
        this.position = "right";
      } else {
        this.position = "left";
      }
      if (e.pageY > 250) {
        this.position2 = "top";
      } else {
        this.position2 = "bottom";
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SendEail()
        } else {
          return false;
        }
      });
    },
    //31e3902a-74b8-4884-8c28-cc9626f9ad41
    //8d926d48-5aa1-41ba-bbe9-632f3439044a
    //smtp.elasticemail.com   2525
    SendEail() {
      let t = this
      var title = ''
      var body = ''
      let data = this.formData
      if (t.contType === 'z') {
        title = "请与 " + data.name + " 联系"
        body = "姓名：" + data.name + "<br><br>"
          + "邮箱：" + data.email + "<br><br>"
          + "电话：" + data.mobile + "<br><br>"
          + "公司名称：" + data.company + "<br><br>"
        if (data.url.length > 0) {
          body = body + "公司官网/产品链接：" + data.url + "<br><br>"
        }
        body = body + "留言：" + data.remark + "<br><br>"
      } else if (t.contType === 'f') {
        title = "請與 " + data.name + " 聯繫"
        body = "姓名：" + data.name + "<br><br>"
          + "郵箱：" + data.email + "<br><br>"
          + "電話：" + data.mobile + "<br><br>"
          + "公司名稱：" + data.company + "<br><br>"
        if (data.url.length > 0) {
          body = body + "公司官網/産品鏈接：" + data.url + "<br><br>"
        }
        body = body + "留言：" + data.remark + "<br><br>"
      } else {
        title = "Please contact " + data.name
        body = "name：" + data.name + "<br><br>"
          + "email：" + data.email + "<br><br>"
          + "mobile：" + data.mobile + "<br><br>"
          + "company：" + data.company + "<br><br>"
        if (data.url.length > 0) {
          body = body + "Suntone's Official Website/Links of Products：" + data.url + "<br><br>"
        }
        body = body + "Message：" + data.remark + "<br><br>"
      }
      t.isSend = true
      Email.send({
        SecureToken: '8d926d48-5aa1-41ba-bbe9-632f3439044a',
        To: 'cs@suntone.com',
        From: "cs@suntone.com",
        Subject: title,
        Body: body
      }).then(
        message => {
          t.isSend = false
          if (message == 'OK') {
            t.$refs.formData.resetFields()
            t.$message({
              showClose: true,
              message: t.contList.email[t.contType],
              type: 'success'
            });
          } else {
            t.$message({
              showClose: true,
              message: message,
              type: 'error'
            });
          }
        }
      );
    },
    changeTypeTitleName() {
      if (this.contType == "f") {
        document.title = "聯繫我們";
      } else if (this.contType == 'e') {
        document.title = 'Contact Us'
      } else {
        document.title = "联系我们";
      }
    }
  },

  mounted() {
    this.bodyW = document.body.clientWidth;
    this.bodyY = document.body.clientHeight;
    var that = this;
    this.contType = window.localStorage.getItem('language');
    that.changeTypeTitleName()
    window.addEventListener('setItemEvent', function (e) {
      if (e.key == "language") {
        that.contType = e.newValue;
        that.changeTypeTitleName()
      }
    })
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 40,
      mobile: true,
      live: true,
    });
    wow.init();
  },
};
</script>

<style src="../assets/css/ContactUs-pc.css"  scoped>

</style>
<style src="../assets/css/ContactUs-phone.css"  scoped>

</style>
